module.exports = __webpack_public_path__ + "img/link-02.8b2c335e.png";